export class GlobalModel {
 public static lang: string = 'tr';
}